<template>
  <div>
    <div
        class="flex flex-wrap -mx-4"
        v-if="can('access-rental-stats') && statsReady"
    >
      <div class="w-full lg:w-1/3 px-4 mb-4">
        <div
            class="h-full bg-white rounded-lg shadow-md hover:shadow-lg transition-slow cursor-pointer"
        >
          <div
              class="flex items-center justify-between px-4 py-2 border-b"
          >
            <h3 class="text-lg font-heading">В наличии</h3>
          </div>

          <div class="flex flex-col px-4 py-2">
            <h3 class="text-3xl font-heading font-semibold">
              {{ stats.stock }}
            </h3>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-1/3 px-4 mb-4">
        <div
            class="h-full bg-white rounded-lg shadow-md hover:shadow-lg transition-slow cursor-pointer"
        >
          <div
              class="flex items-center justify-between px-4 py-2 border-b"
          >
            <h3 class="text-lg font-heading">В аренде</h3>
          </div>

          <div class="flex flex-col px-4 py-2">
            <h3 class="text-3xl font-heading font-semibold">
              {{ stats.rent }}
            </h3>
          </div>
        </div>
      </div>
    </div>

    <resource-index title="Аренда" endpoint="admin/billing/rentals">
      <template slot="header-buttons">
        <router-link
            class="btn btn-secondary"
            :to="{
                        name: 'admin.billing.rentals.create',
                    }"
        >Создать
        </router-link
        >
      </template>

      <template v-slot:table-header>
        <tr class="border-b">
          <th class="text-left p-3 px-5" scope="col">Товар</th>
          <th class="text-left p-3 px-5" scope="col">Город</th>
          <th class="text-left p-3 px-5" scope="col">Клиент</th>
          <th class="text-left p-3 px-5" scope="col">Стоимость</th>
          <th class="text-left p-3 px-5" scope="col">Окончание</th>
          <th class="text-left p-3 px-5" scope="col">Статус</th>
          <th class="text-left p-3 px-5" scope="col">Тип</th>
          <th class="text-left p-3 px-5" scope="col"></th>
        </tr>
      </template>

      <template v-slot:table-filters="slotProps">
        <tr class="border-b bg-gray-100">
          <th class="p-3 px-5" scope="col">
            <text-field
                placeholder="Название или ID"
                :wrap="false"
                v-model="slotProps.filters.product_name"
            />
          </th>

          <th class="p-3 px-5" scope="col">
            <select-field
                label="name"
                valueName="id"
                :wrap="false"
                :options="selects.branches"
                v-model="slotProps.filters.branch_id"
            />
          </th>

          <th class="p-3 px-5" scope="col">
            <text-field
                :wrap="false"
                v-model="slotProps.filters.customer"
            />
          </th>

          <th class="p-3 px-5" scope="col"></th>
          <th class="p-3 px-5" scope="col"></th>

          <th class="p-3 px-5" scope="col">
            <select-field
                label="label"
                valueName="name"
                :wrap="false"
                :options="selects.statuses"
                v-model="slotProps.filters.status"
            />
          </th>

          <th class="p-3 px-5" scope="col">
            <select-field
                label="label"
                valueName="value"
                :wrap="false"
                :options="selects.types"
                v-model="slotProps.filters.type"
            />
          </th>

          <th class="p-3 px-5" scope="col"></th>
        </tr>
      </template>

      <template v-slot:row="slotProps">
        <td class="p-3 px-5">
          {{ slotProps.entry.product.unique_id }} –
          {{ slotProps.entry.product.name }}
        </td>

        <td class="p-3 px-5">
          {{
            slotProps.entry.product.branch
                ? slotProps.entry.product.branch.name
                : "–"
          }}
        </td>

        <td class="p-3 px-5">
          {{ slotProps.entry.customer.full_name }}
        </td>

        <td class="p-3 px-5">
                    <span class="badge whitespace-no-wrap badge-success"
                    >{{ slotProps.entry.amount }} ₽</span
                    >
        </td>

        <td class="p-3 px-5">
          {{ localTime(slotProps.entry.ends_at) }}
        </td>

        <td class="p-3 px-5">
                    <span
                        class="badge whitespace-no-wrap badge-success"
                        v-if="slotProps.entry.returned_at"
                    >Возвращен</span
                    >
          <span
              class="badge whitespace-no-wrap badge-danger"
              v-else-if="slotProps.entry.is_expired"
          >Просрочен</span
          >
          <span
              class="badge whitespace-no-wrap badge-warning"
              v-else-if="slotProps.entry.return_soon"
          >&lt;3 дней</span
          >
          <span class="badge whitespace-no-wrap badge-indigo" v-else
          >Аренда</span
          >
        </td>

        <td class="p-3 px-5">
          <router-link
              :to="{
                            name: 'admin.billing.rentals.edit',
                            params: {
                                id: slotProps.entry.id,
                            },
                        }"
              class="btn btn-info"
          >Изменить
          </router-link
          >
        </td>
      </template>
    </resource-index>
  </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";
import qs from "qs";

export default {
  components: {
    ResourceIndex,
  },

  data() {
    return {
      stats: {},
      statsReady: false,
      selects: {
        types: [
          {
            label: 'Аренда ученику',
            value: 'for_pupil'
          },
          {
            label: 'Аренда прорыв (включена в стоимость курса)',
            value: 'for_breakthrough'
          },
          {
            label: 'Аренда инициация (включена в стоимость курса)',
            value: 'for_initiating'
          },
          {
            label: 'Аренда вип абонемент (включена в стоимость курса)',
            value: 'vip_subscription'
          },
          {
            label: 'Аренда партнеру',
            value: 'for_partner'
          }
        ],
        ready: false,
        products: [],
        statuses: [
          {
            name: "rent",
            label: "Аренда",
          },
          {
            name: "returned",
            label: "Возвращен",
          },
          {
            name: "paid",
            label: "Оплачен",
          },
        ],
      },
    };
  },

  methods: {
    async fetchStats() {
      await axios.get(`/admin/billing/rentals/stats`).then((response) => {
        this.stats = response.data.data;
      });

      this.statsReady = true;
    },

    async fetchSelects() {
      /*
      await axios.get("/admin/products/all").then(response => {
          this.selects.products = response.data.data;
      });
      */

      await axios.get("/admin/branches/all").then((response) => {
        this.selects.branches = response.data.data;
      });

      this.selects.ready = true;
    },
  },

  mounted() {
    this.fetchSelects();
    this.fetchStats();
  },
};
</script>
